<template>
  <div>
    <n-popover trigger="click" :theme-overrides="themeOverrides">
      <template #trigger>
        <div>
          <svg-icon class="avatar_icon" icon-name="avatarHeadSvg" icon-class="avatarHeadSvg"> </svg-icon>
        </div>
      </template>
      <div>
        <div class="user_info_container">
          <div class="user_info_avatar">
            {{ name.slice(0, 1) }}
          </div>
          <div class="user_info">
            <div class="user_info_name">{{ name }}</div>
            <!-- <div class="user_info_role">{{ isDataGovernancePath ? vpRoleStr : roleNamesStr }}</div> -->
            <div v-if="isDataGovernancePath">{{ vpRoleStr }}</div>
            <div v-else class="user_info_dbo">
              <template v-for="(item, index) in roleVoList" :key="index">
                <n-popover v-if="item.dbos?.length" trigger="hover">
                  <template #trigger>
                    <div class="user_info_dbo_item">{{ item.roleName }}</div>
                  </template>
                  <span>{{ item.dbos?.join(', ') }}</span>
                </n-popover>

                <div v-else>{{ item.roleName }}</div>
                <!-- <span v-if="index < roleVoList.length - 1">, </span> -->

                <!-- <div v-if="index < roleVoList.length - 1" class="border-1px" /> -->
              </template>
            </div>
          </div>
        </div>
        <hr class="hr_line" />
        <div class="userInfo_signOut">
          <svg-icon class="signOut_icon" icon-name="backSignOutSvg" icon-class="backSignOutSvg"> </svg-icon>
          <span @click="signOut"> Sign Out</span>
        </div>
      </div>
    </n-popover>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { loginOut } from '@/api/login';
import { removeToken } from '@/utils/storage';

const themeOverrides = {
  padding: 0,
  borderRadius: '6px',
};
const route = useRoute();

const props = defineProps({
  name: {
    type: String,
    default: '',
  },
  roleNames: {
    type: Array,
    default: () => [],
  },
  roleVoList: {
    type: Array,
    default: () => [],
  },
  vpRoleStr: {
    type: String,
    default: '',
  },
});

const roleNamesStr = computed(() => {
  return props.roleNames.join(',');
});

const isDataGovernancePath = computed(() => {
  return route.path === '/dataGovernace';
});

const signOut = () => {
  loginOut().then((res) => {
    const targetOrigin = import.meta.env.VITE_GLOB_Vprivacy;
    const $frame_vprivacy: any = document.getElementById('frame_vprivacy');
    if ($frame_vprivacy) {
      const data = {
        type: 'logOut',
      };
      $frame_vprivacy.contentWindow.postMessage(JSON.stringify(data), targetOrigin);
    }
    removeToken('userInfo');
    removeToken('Admin-Token');
    window.location.href = res;
  });
};
</script>

<style lang="scss">
@import '@/styles/_global.scss';

.avatar_icon {
  font-size: 20px;
  margin-left: 32px;
  cursor: pointer;

  &:hover {
    color: $color-primary;
  }
}
.userInfo_name {
  color: rgb(42, 43, 56);
  margin-bottom: 8px;
  font-size: 16px;
  text-align: center;
}
.userInfo_role {
  color: rgb(42, 43, 56);
  font-size: 12px;
  text-align: center;
  margin-bottom: 8px;
}
.userInfo_signOut {
  display: flex;
  align-items: center;
  padding: 17px 0;
  padding-left: 20px;
  cursor: pointer;
  &:hover {
    color: $color-primary;
  }
}
.hr_line {
  color: #e5e5e5;
}
.signOut_icon {
  font-size: 20px;
  margin-right: 12px;
}
.user_info_container {
  display: flex;
  padding: 26px 20px;
}
.user_info_avatar {
  width: 48px;
  min-width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: $color-primary;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  color: #fff;
  font-size: 14px;
}
.user_info_name {
  color: #262626;
  font-weight: bold;
  font-size: 16px;
}
.user_info_role {
  color: #666;
  font-size: 14px;
  max-width: 300px;
}
.user_info_dbo {
  color: #666;
  font-size: 14px;
  max-width: 300px;
  // margin-top: 10px;
  // white-space: nowrap;
  // text-overflow: ellipsis;
  // overflow: hidden;

  // .user_info_dbo_item {
  //   padding: 5px 0;
  // }
}
</style>
